import nxModule from 'nxModule';
import ParameterizedLocalCache from 'shared/utils/parameterized-local-cache';

nxModule.factory('ataCache', (http, CacheFactory, config) =>
  new ParameterizedLocalCache({
    provider: (accountId) => http.get(`/products/accounts/${accountId}/ata`),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.ata,
    cacheName: 'ataCache'
  })
);
